export default "__VITE_ASSET__ChG8XYkr__"